import React from "react";
import { RootUrl } from "../../../redux/types";
import haptics from "../../../helpers/haptics";

const MobileCategories = ({ categories, selectedCategory, onSelectCategory }) => {
  const allCategories = [
    { categoryName: "all", categoryImage: null },
    ...(categories || []),
  ];

  const getCategoryIcon = (categoryName) => {
    // Fallback icons for categories without images
    const iconMap = {
      all: "mdi mdi-food",
      Starter: "mdi mdi-food-variant",
      Punjabi: "mdi mdi-food-turkey",
      Gujarati: "mdi mdi-bowl-mix",
      Chinese: "mdi mdi-noodles",
      Italian: "mdi mdi-pasta",
      Dessert: "mdi mdi-cupcake",
    };
    return iconMap[categoryName] || "mdi mdi-food";
  };

  return (
    <div className="px-3 mb-2">
      <h5 className="fw-bold text-dark mb-3">Categories</h5>
      <div className="d-flex gap-3 overflow-auto pb-2 mobile-categories-scroll">
        {allCategories.map((category, index) => (
          <div
            key={index}
            className="text-center cursor-pointer flex-shrink-0 mobile-category-item"
            onClick={() => {
              haptics.medium();
              onSelectCategory(category.categoryName);
            }}
          >
            <div 
              className={`rounded-circle d-flex align-items-center justify-content-center mb-2 mx-auto mobile-category-icon ${
                selectedCategory === category.categoryName ? 'mobile-category-active' : 'mobile-category-inactive'
              }`}
            >
              {category.categoryImage ? (
                <img
                  src={`${RootUrl}/${category.categoryImage}`}
                  alt={category.categoryName}
                  className="rounded-circle w-100 h-100 mobile-category-img"
                />
              ) : (
                <i
                  className={`${getCategoryIcon(category.categoryName)} mobile-category-icon-font`}
                ></i>
              )}
            </div>
            <small 
              className={`d-block mobile-category-name ${
                selectedCategory === category.categoryName ? 'fw-bold text-dark' : 'text-muted'
              }`}
              title={category.categoryName === "all" ? "All" : category.categoryName}
            >
              {category.categoryName === "all" ? "All" : category.categoryName}
            </small>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileCategories;

